import { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "../../shared/model/routes";
import { fetchSiteEvents, readSiteEventsCache, type SiteEvent } from "../../shared/model/siteContent";
import { pickNearestSiteEvent } from "../../shared/model/nearest-site-event";

export const HomeNextShow: FC = () => {
  const [items, setItems] = useState<SiteEvent[]>(() => readSiteEventsCache() ?? []);

  useEffect(() => {
    let alive = true;
    fetchSiteEvents()
      .then((remote) => {
        if (!alive || !remote?.length) return;
        setItems(remote);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  const nextShow = pickNearestSiteEvent(items);
  if (!nextShow) return null;

  const title = nextShow.name.trim() || "Спектакль";
  const dateLabel = nextShow.date?.trim() ?? "";
  const href = `/${ROUTES.EVENTS}/${encodeURIComponent(nextShow.slug)}`;
  const label = dateLabel ? `${title}, ${dateLabel}` : title;

  return (
    <Link to={href} className="chalk-page__next-show" aria-label={label}>
      {dateLabel ? <span className="chalk-page__next-show-date">{dateLabel}</span> : null}
      <span className="chalk-page__next-show-title">{title}</span>
    </Link>
  );
};
